import React from 'react';

import { TwoTilesBlockData } from 'api/cms';
import { AmpSplitContentBlock } from 'cms/blocks/Amp/AmpSplitContentBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpTwoTilesBlock({
  data,
}: AmpBlockMappingComponentProps<TwoTilesBlockData>) {
  const buttonOne =
    data.tileOneButtonText && data.tileOneButtonUrl
      ? {
          text: data.tileOneButtonText,
          data: {
            ur: data.tileOneButtonUrl,
          },
        }
      : null;

  const buttonTwo =
    data.tileTwoButtonText && data.tileTwoButtonUrl
      ? {
          text: data.tileTwoButtonText,
          data: {
            ur: data.tileTwoButtonUrl,
          },
        }
      : null;

  return (
    <AmpSplitContentBlock
      data={{
        sections: [
          {
            type: 'TEXT',
            data: {
              headline: data.tileOneHeadline,
              html: data.tileOneText,
              // @ts-expect-error Fix me
              button: buttonOne,
            },
          },
          {
            type: 'TEXT',
            data: {
              headline: data.tileOneHeadline,
              html: data.tileOneText,
              // @ts-expect-error Fix me
              button: buttonTwo,
            },
          },
        ],
      }}
    />
  );
}
